// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../utils/dispatchToProps';
import type { InvitesState, State } from '../../types/state';
import { ConnectedSectionWrapper } from '../shared/section-wrapper';
import { returnSubsetById } from '../../utils/stateHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accountsGetInvites, accountsRevokeInvite } from '../../actions/accounts';

type Props = {
	invites: InvitesState;
	accountsGetInvites: typeof accountsGetInvites;
	accountsRevokeInvite: typeof accountsRevokeInvite;
};

export class AccountInvites extends Component<Props> {

	componentWillMount() {
		this.loadData();
	}

	componentWillUpdate() {

	}

	loadData = () => {
		this.props.accountsGetInvites();
	};

	render() {
		let invites = returnSubsetById( this.props.invites.ids, this.props.invites.objects );

		return (
			<ConnectedSectionWrapper
				title={"Pending Invitations"}
				render={() => (
					<div>
						{invites.length > 0 && invites.map( invite => (
							<div className="box level" key={invite.id}>
								<div className="level-left">
									{invite.email}
								</div>
								<div className="level-right">
									<button className="button is-danger level-item" onClick={() => { this.props.accountsRevokeInvite( invite.id ); }}>
											<span className="icon is-small">
												<FontAwesomeIcon icon="trash" />
											</span>
										<span>Revoke</span>
									</button>
								</div>
							</div>
						))}
						{invites.length === 0 && (
							<div className="content has-text-centered">
								<p>You do not have any invites at this time.</p>
							</div>
						)}
					</div>
				)}
			/>
		)
	}

}

const mapStateToProps = ( state: State ) => ( {
	invites: state.accounts.invites,
} );

export const ConnectedAccountInvites = connect( mapStateToProps, mapDispatchToProps )( AccountInvites );
